import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import WhatIfClientRedefinedLayout
  from 'Views/Page/Content/Templates/WhatIfClientRedefinedTemplate/WhatIfClientRedefinedLayout';
import DataContainer from 'Components/UI/DataContainer';
import FacetPlanProposalScenarioSelectionIntroPage
  from 'Views/Page/Content/Templates/FacetPlanProposalScenarioSelectionIntroPageTemplate';
import fr from 'facet-rest';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { useSnackbarContext } from 'Context/SnackbarContext';

// We either need to show the intro page or the view for a specific scenario, depending on what buttons
// the user clicks. When the user clicks a review button on the intro page (onAgentReview) we show the scenario view.
// When they click the view all scenarios button on the scenario view (onAgentViewAllScenarios), we show the intro page.
const Content = ({
  resource,
}) => {
  const [clientViewRedefinedResource, setClientViewRedefinedResource] = React.useState(resource.type() === 'FacetPlanClientViewRedefined' ? resource : null);
  const { displayErrorMessage } = useSnackbarContext();

  useEffect(() => {
    if (resource.type() === 'FacetPlanClientViewRedefined') {
      setClientViewRedefinedResource(resource);
    }
  }, [resource]);

  const onAgentReview = async (resourceWithRel) => {
    try {
      await resourceWithRel.withRelationship(
        fr.relationships.reviewScenario.name,
        async (rel) => {
          const [collectionFromReviewScenario] = await rel.link('related').get();
          setClientViewRedefinedResource(collectionFromReviewScenario);
        },
        () => { throw new Error('Review scenario relationship not found on resource'); },
      );
    } catch (err) {
      if (err.errors) {
        displayErrorMessage(err, err.errors);
      } else {
        displayErrorMessage(err, 'Error: Button click failed, please contact product support.');
      }
    }
  };

  const onAgentViewAllScenarios = async (resourceWithRel) => {
    try {
      await resourceWithRel.withRelationship(
        fr.relationships.facetPlanProposalScenarioSelectionIntroPage.name,
        async () => {
          setClientViewRedefinedResource(null);
        },
        () => { throw new Error('Intro page relationship not found on resource'); },
      );
    } catch (err) {
      if (err.errors) {
        displayErrorMessage(err, err.errors);
      } else {
        displayErrorMessage(err, 'Error: Button click failed, please contact product support.');
      }
    }
  };

  if (clientViewRedefinedResource) {
    return (<DataContainer
      component={MetaResourceRenderer}
      componentProps={{
        resource: clientViewRedefinedResource,
        layout: WhatIfClientRedefinedLayout,
        LayoutProps: {
          onAgentViewAllScenarios,
        },
      }}
    />);
  }

  return (<DataContainer
    component={FacetPlanProposalScenarioSelectionIntroPage}
    componentProps={{
      resource,
      onAgentReview,
    }}
    loading={!resource}
  />);
};

Content.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default Content;
